<form
  autocomplete="off"
  class="flex flex-wrap justify-start items-center gap-2"
  [formGroup]="filterForm"
>
  <mat-form-field appearance="outline">
    <mat-label>Geography</mat-label>
    <mat-select formControlName="geographicTargets" multiple>
      @for (geography of geographiesList; track geography) {
        <mat-option [value]="geography">
          {{ geography }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Profile type</mat-label>
    <mat-select formControlName="profileTypes" multiple>
      @for (profileType of profileTypesList; track profileType) {
        <mat-option [value]="profileType">
          {{ profileType }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Affiliations</mat-label>
    <mat-select formControlName="affiliations" multiple>
      @for (affiliation of affiliationsList; track affiliation) {
        <mat-option [value]="affiliation">
          {{ affiliation }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Name</mat-label>
    <input matInput formControlName="expertName" />
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Bio/Screener content</mat-label>
    <input matInput formControlName="bioContent" />
  </mat-form-field>

  @if (viewStage === 'new') {
    <mat-checkbox
      formControlName="showNearPass"
      data-test-id="expert-filter-show-near-pass-experts"
      >Show near pass experts</mat-checkbox
    >
  }

  <button
    mat-icon-button
    color="primary"
    [disabled]="!formHasValues"
    (click)="resetForm()"
  >
    <mat-icon>clear</mat-icon>
  </button>
</form>
